// cSpell:ignore Alles eigenaar keer
import { Stack, TextStyle } from "@rentiohq/web-shared/dist/components";
import {
  IOwnerPayGroups,
  ownerGroupLabel,
  withoutOwnerLabel,
} from "../ownerPayGroups.utils";

interface IOwnerGroupListProps<Share> {
  grouped: IOwnerPayGroups<Share>;
  // While the forms run: the one showing now, as getOwnerPayRuns orders
  // them (the owners first, then the tenants without an owner).
  currentRunIndex?: number;
  // A tenant who has a payment order already.
  isBilled?: (share: Share) => boolean;
}

// "Alles in één keer per eigenaar": one line per owner with their tenant
// count, and one for the tenants without an owner, who are billed one by one.
// While the forms run, the owner (or the tenant without one) whose form shows
// is in bold, and an owner whose tenants are all billed is greyed out.
export const OwnerGroupList = <Share,>({
  grouped,
  currentRunIndex,
  isBilled,
}: IOwnerGroupListProps<Share>) => {
  const { groups, withoutOwner } = grouped;
  const isCurrent = (index: number) =>
    currentRunIndex != null &&
    (index < groups.length
      ? currentRunIndex === index
      : currentRunIndex >= groups.length);
  const isDone = (shares: Share[]) => !!isBilled && shares.every(isBilled);
  const variationOf = (index: number, shares: Share[]) => {
    if (isCurrent(index)) return "strong";
    return isDone(shares) ? "subdued" : "default";
  };
  const lines = [
    ...groups.map(group => ({
      key: group.ownerKey,
      label: ownerGroupLabel(group),
      shares: group.shares,
    })),
    ...(withoutOwner.length > 0
      ? [
          {
            key: "without-owner",
            label: withoutOwnerLabel(withoutOwner.length),
            shares: withoutOwner,
          },
        ]
      : []),
  ];
  return (
    <Stack vertical spacing="extraTight">
      {lines.map((line, index) => (
        <TextStyle
          key={line.key}
          element="div"
          variation={variationOf(index, line.shares)}
        >
          {line.label}
        </TextStyle>
      ))}
    </Stack>
  );
};
